import React from "react";
import moment from "moment";
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { AiFillTwitterCircle } from "react-icons/ai";
import logoholexo from "../images/Logo/holexo.png";
import { HiOutlineMail } from "react-icons/hi";
import { FiPhone } from "react-icons/fi";
import { BsWhatsapp } from "react-icons/bs";
import { FaLongArrowAltRight } from "react-icons/fa";
class webfooter extends React.Component {
  render() {
    return (
      <>
        <div className="footer deskview">
          <div className="container-lg container-fluid-md px-md-4 px-sm-4">
            <div className="row">
              <div className="col-lg-5 col-sm-12">
                <a href="/">
                  <img
                    className="imglogo"
                    style={{ cursor: "pointer" }}
                    src={logoholexo}
                    alt="Holxo"
                  />
                </a>
                <p className="avenir_regular footerpehra">
                  Holxo offers holistic and customized holidays, specially
                  curated by our travel experts with the best combination of
                  handpicked hotels and experiences to suit your taste and
                  budget.
                </p>

                <ul className="d-flex mb-4">
                  <li>
                    <a
                      href="https://www.facebook.com/HolxoHolidays"
                      target="_blank"
                    >
                      <FaFacebook
                        className="footer_icon ms-0"
                        style={{ fontSize: "30px" }}
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/holxoholidays/"
                      target="_blank"
                    >
                      <FaInstagram
                        className="footer_icon mx-0"
                        style={{ fontSize: "30px" }}
                      />
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/HolxoHolidays" target="_blank">
                      <AiFillTwitterCircle
                        className="footer_icon"
                        style={{ fontSize: "30px" }}
                      />
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-lg-4 col-sm-12">
                <h2 className="text-white">Quick Links</h2>
                <ul className="avenir_regular mb-4">
                  <li className="mx-1">
                    <a
                      className="footerlinkhovercolor"
                      style={{ color: "#888888", textDecoration: "none" }}
                      href="/aboutus"
                    >
                      About Us
                    </a>
                  </li>
                  <li className="mx-1">
                    <a
                      className="footerlinkhovercolor"
                      style={{ color: "#888888", textDecoration: "none" }}
                      href="/contact"
                    >
                      Contact Us
                    </a>
                  </li>
                  <li className="mx-1">
                    <a
                      className="footerlinkhovercolor"
                      style={{ color: "#888888", textDecoration: "none" }}
                      href="/termsandconditions"
                    >
                      Terms &amp; Conditions
                    </a>
                  </li>
                  <li className="mx-1">
                    <a
                      className="footerlinkhovercolor"
                      style={{ color: "#888888", textDecoration: "none" }}
                      href="/privacy"
                    >
                      Privacy
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 col-sm-12">
                <h2 className="text-white">Contact Us</h2>
                <ul className="mb-4">
                  <li>
                    <a class="buttonenqfooter top text-white" href="/contact">
                      Quick Enquiry <FaLongArrowAltRight />
                    </a>
                  </li>
                  <li>
                    <FiPhone className="emailcoloricon" />
                    <span className="ms-1 footer_num">
                      <a
                        href="tel:+91 9810070789"
                        className="numberhoverfooter"
                      >
                        +91 98100 70789
                      </a>
                    </span>
                  </li>
                  <li>
                    <FiPhone className="emailcoloricon" />
                    <span className="ms-1 footer_num">
                      <a
                        href="tel:+91 9873998300"
                        className="numberhoverfooter"
                      >
                        +91 98739 98300
                      </a>
                    </span>
                  </li>
                  <li>
                    <HiOutlineMail className="emailcoloricon" />
                    <span className="ms-1 footer_mail">
                      <a
                        href="mailto:varun@holxoholidays.com"
                        className="numberhoverfooter"
                      >
                        varun@holxoholidays.com
                      </a>
                    </span>
                  </li>
                  <li>
                    <HiOutlineMail className="emailcoloricon" />
                    <span className="ms-1 footer_mail">
                      <a
                        href="mailto:mitali@holxoholidays.com"
                        className="numberhoverfooter"
                      >
                        mitali@holxoholidays.com
                      </a>
                    </span>
                  </li>
                </ul>
                <div
                  className="avenir_regular footernumblock"
                  style={{ color: "#888888" }}
                ></div>
              </div>
            </div>
            <div
              className="row m-0 justify-content-between border-top mt-3 pt-3 footercopyright"
              style={{ color: "#888888" }}
            >
              <p className="col-auto px-0 mx-0 avenir_regular">
                Design
                <a
                  href="http://globaltrendz.com/"
                  target="_blank"
                  className="footerglobalhovercolor"
                >
                  Global Trendz
                </a>
              </p>
              <div className="col-auto d-flex px-0 mx-0 footerRight ">
                <p className="avenir_regular">
                  Copyright © {moment().format("YYYY")} Holxo. All Rights
                  Reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="sticky-side-bar">
          <a
            href="https://wa.me/+919810070789?text=Hey! Holexo, I have a Query"
            class="whatsapp"
            target="_blank"
            type="button"
            rel="noreferrer"
          >
            <BsWhatsapp style={{ fontSize: "30px" }} /> &nbsp;&nbsp; Ask Me
          </a>
        </div>
      </>
    );
  }
}
export default webfooter;
